<template>
  <div class="container-fluid py-4">

    <h2 class="mb-4">{{ unit ? unit.productName : "Unit Details" }}</h2>

    <div v-if="unit" class="row">

      <div class="col-md-7">
        <div class="card shadow-sm mb-4">
          <div class="card-body p-0">

            <b-carousel
              v-if="unit.documentUploads?.length"
              controls indicators
              background="#ababab"
              :interval="4000"
              img-width="1024"
              img-height="480"
              class="rounded"
            >
              <b-carousel-slide
                v-for="doc in unit.documentUploads"
                :key="doc.id"
                :img-src="`${apiBaseUrl}${doc.fileUrl}`"
              />
            </b-carousel>

            <div v-else class="image-placeholder d-flex align-items-center justify-content-center">
              <i class="bi bi-image-fill text-muted"></i>
            </div>

          </div>
        </div>
      </div>

      <div class="col-md-5">

        <div class="card shadow-sm mb-4">
          <div class="card-body">

            <h1 class="product-title">{{ unit.productName }}</h1>
            <p class="text-muted lead mb-2">Unit ID: {{ unit.id }}</p>

            <p class="badge" :class="unit.assigned ? 'bg-success' : 'bg-warning text-dark'">
              {{ unit.assigned ? 'Assigned' : 'Unassigned' }}
            </p>

            <hr>

            <div class="details-section">
              <h6>Unit Specifications</h6>

              <div class="row mb-2">
                <div class="col-5 text-muted">Serial Number:</div>
                <div class="col-7 font-weight-bold">{{ unit.serialNumber }}</div>
              </div>

              <div class="row mb-2">
                <div class="col-5 text-muted">Category:</div>
                <div class="col-7 font-weight-bold">{{ unit.categoryName }}</div>
              </div>

              <div class="row mb-2">
                <div class="col-5 text-muted">Stock Type:</div>
                <div class="col-7 font-weight-bold">Single Unit</div>
              </div>
            </div>

            <hr>

            <div class="description-section">
              <h6>Product Description</h6>
              <p class="text-secondary small">
                {{ product?.description || "No description available." }}
              </p>
            </div>

            <div class="mt-4">
              <b-button variant="primary" block size="lg">Buy This Unit</b-button>
              <b-button variant="outline-secondary" block>Contact Seller</b-button>
            </div>

          </div>
        </div>

      </div>

    </div>

    <div v-else class="text-center py-5 text-muted">
      Loading unit details...
    </div>

  </div>
</template>

<script>
export default {
  name: "UnitDetailsPage",

  data() {
    return {
      unit: null,
      product: null,
      apiBaseUrl: " ",
    };
  },

created() {
   this.unit = JSON.parse(localStorage.getItem("unitToView"));
  this.product = JSON.parse(localStorage.getItem("productForUnit"));
}

};
</script>

<style scoped>
.product-title { font-weight: 600; }
.image-placeholder {
  height: 480px;
  background: #f8f9fa;
  font-size: 5rem;
  border-radius: 0.25rem;
}
</style>
